import React from 'react';
import PropTypes from 'prop-types';

export default class EventFilter extends React.Component {
   constructor(props) {
      super(props);

      this.state = {
         term: ''
      };

      this.handleFilter = this.handleFilter.bind(this);
   }

   handleFilter(event) {
      const term = event.target.value;
      this.setState(
         {
            term
         },
         () => {
            this.props.filter(term);
         }
      );
   }

   render() {
      const { term } = this.state;
      return (
         <div className="eventFilter">
            <input
               className="eventFilter_input"
               name="term"
               type="text"
               value={term}
               placeholder="Søk"
               onChange={this.handleFilter}
            />
         </div>
      );
   }
}

EventFilter.propTypes = {
   filter: PropTypes.func
};
